import { ComponentStyleConfig } from '@chakra-ui/react';

const SpinnerTheme: ComponentStyleConfig = {
  sizes: {
    xs: {
      w: '24px',
      h: '24px',
      borderWidth: '2px'
    },
    sm: {
      w: '32px',
      h: '32px',
      borderWidth: '3px'
    },
    md: {
      w: '48px',
      h: '48px',
      borderWidth: '5px'
    },
    lg: {
      w: '64px',
      h: '64px',
      borderWidth: '6px'
    }
  }
};

export default SpinnerTheme;
